export const CASE_STUDY_1_CONSTANTS = {
  DEFAULT_ROW: {
    id: "1",
    meta_image: "",
    meta_alt_image: "",
    meta_logo_image: "",
    meta_title: "",
    meta_title_color: "#000000",
    meta_sub_title: "",
    meta_sub_title_color: "rgba(0,0,0,0.8)",
    meta_priority: "1",
  },

  CARD_FIELDS_CONFIG: [],

  CASE_STUDY_FIELDS_CONFIG: [
    {
      fieldName: "desktop_background_color",
      label: "Desktop Background Color",
      value: "",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Select desktop background color",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "mobile_background_color",
      label: "Mobile Background Color",
      value: "",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Select mobile background color",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "backvariant",
      label: "Background Variant",
      value: "variant_1",
      valueType: "string",
      filedType: "SELECT",
      placeholder: "Select background variant",
      required: false,
      defaultValue: "variant_1",
      options: [
        { label: "Variant 1", value: "variant_1" },
        { label: "Variant 2", value: "variant_2" },
        { label: "Variant 3", value: "variant_3" },
      ],
    },
    {
      fieldName: "gradient_color_1",
      label: "Gradient Color 1",
      value: "",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Select gradient color 1",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "gradient_color_2",
      label: "Gradient Color 2",
      value: "",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Select gradient color 2",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "gradient_color_3",
      label: "Gradient Color 3",
      value: "",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Select gradient color 3",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "gradient_color_4",
      label: "Gradient Color 4",
      value: "",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Select gradient color 4",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "font_style",
      label: "Font Style",
      value: "",
      valueType: "string",
      filedType: "SELECT",
      placeholder: "Select font style",
      required: false,
      defaultValue: "var(--font-merriweather)",
      options: [
        { label: "Google Sans", value: "var(--font-google-sans)" },
        { label: "Merriweather", value: "var(--font-merriweather)" },
        { label: "Circular Std", value: "var(--font-circular-std)" },
      ],
    },
    {
      fieldName: "title",
      label: "Title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter title",
      required: false,
      defaultValue: "Solve actual wealth",
    },
    {
      fieldName: "title_color",
      label: "Title Color",
      value: "",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Select title color",
      required: false,
      defaultValue: "#222222",
    },
    {
      fieldName: "title_highlight",
      label: "Title Highlight",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter highlighted title text",
      required: false,
      defaultValue: "management challenges",
    },
    {
      fieldName: "title_highlight_color",
      label: "Title Highlight Color",
      value: "",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Select title highlight color",
      required: false,
      defaultValue: "#342B7C",
    },
    {
      fieldName: "description",
      label: "Description",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter description",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "description_color",
      label: "Description Color",
      value: "",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Select description color",
      required: false,
      defaultValue: "rgba(0,0,0,0.7)",
    },
    {
      fieldName: "button_text",
      label: "Button Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter button text",
      required: false,
      defaultValue: "Apply Now",
    },
    {
      fieldName: "button_start_color",
      label: "Button Start Color",
      value: "",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Select button start color",
      required: false,
      defaultValue: "#342B7C",
    },
    {
      fieldName: "button_end_color",
      label: "Button End Color",
      value: "",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Select button end color",
      required: false,
      defaultValue: "#02A7B6",
    },
    {
      fieldName: "button_gradient_direction",
      label: "Button Gradient Angle",
      value: "0deg",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter angle, e.g. 0deg or 180deg",
      required: false,
      defaultValue: "0deg",
    },
    {
      fieldName: "button_text_color",
      label: "Button Text Color",
      value: "",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Select button text color",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "left_navigation_icon",
      label: "Left Navigation Icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload left navigation icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "alt_text_left_nav_icon",
      label: "Alt Text Left Nav Icon",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for left navigation icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "right_navigation_icon",
      label: "Right Navigation Icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload right navigation icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "alt_text_right_nav_icon",
      label: "Alt Text Right Nav Icon",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for right navigation icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "scroll_frequency",
      label: "Scroll Frequency",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter scroll frequency",
      required: false,
      defaultValue: "0",
    },
    {
      fieldName: "enable_animation",
      label: "Enable Animation",
      value: "",
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable animation",
      required: false,
      defaultValue: false,
    },
    {
      fieldName: "status",
      label: "Status",
      value: "",
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Set status",
      required: false,
      defaultValue: false,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Image",
      fieldName: "meta_image",
      label: "Image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload image",
      required: false,
      defaultValue: "",
    },
    {
      header: "Alt Image",
      fieldName: "meta_alt_image",
      label: "Alt Image",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for image",
      required: false,
      defaultValue: "",
    },
    {
      header: "Logo Image",
      fieldName: "meta_logo_image",
      label: "Logo Image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload logo image",
      required: false,
      defaultValue: "",
    },
    {
      header: "Title",
      fieldName: "meta_title",
      label: "Title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter title",
      required: false,
      defaultValue: "",
    },
    {
      header: "Title Color",
      fieldName: "meta_title_color",
      label: "Title Color",
      value: "",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Select title color",
      required: false,
      defaultValue: "#000000",
    },
    {
      header: "Sub Title",
      fieldName: "meta_sub_title",
      label: "Sub Title",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter sub title",
      required: false,
      defaultValue: "",
    },
    {
      header: "Sub Title Color",
      fieldName: "meta_sub_title_color",
      label: "Sub Title Color",
      value: "",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Select sub title color",
      required: false,
      defaultValue: "rgba(0,0,0,0.8)",
    },
    {
      header: "Priority",
      fieldName: "meta_priority",
      label: "Priority",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter priority",
      required: false,
      defaultValue: "1",
    },
  ],
};

export default CASE_STUDY_1_CONSTANTS;
